import React from "react";
import s from "./Navigation.module.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface Props {
  navigation: {
    name: string;
    path: string;
  };
}

const Navigation: React.FC<Props> = ({ navigation }) => {
  const { t } = useTranslation();
  const translatedPath = navigation.name
    .split(" / ")
    .map((part) => t(part.trim()))
    .join(" / ");

  return (
    <div className={s.content}>
      <div className={s.button}>
        <Link to={navigation.path} className={s.btn}>
          <img src="/images/arrow_left.svg" className={s.btn_icon} />
        </Link>
      </div>
      <div className={s.path}>{translatedPath}</div>
    </div>
  );
};

export default Navigation;
